import axios from "axios";

export const createIssue = async (feedback, feedbackLabels) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_RECIPE_API_BASE_URL}/feedback`,
      {
        title: feedback,
        labels: feedbackLabels,
      },
      { withCredentials: true }
    );
    console.log(response);
    return response;
  } catch (error) {
    console.error(error);
  }
};
